module.exports = __webpack_public_path__ + "img/bg.e61045af.png";